import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {NgClass, PercentPipe} from "@angular/common";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {AksjenummerintervallerPipe} from "felles-ng2/pipes/AksjenummerintervallerPipe";
import {InlineMeldingKomponent} from "web-ng2/delt/komponenter/inline-melding/inline-melding";
import {BeholdningerSkjemamodell} from "../aksjeeiere-rediger-beholdning/aksjeeiere-rediger-beholdning";
import {AntallAksjerPerAksjeklasseKomponent} from "web-ng2/moduler/aksjeeierbok/komponenter/antall-aksjer-per-aksjeklasse/antall-aksjer-per-aksjeklasse";
import {TranslateModule} from "@ngx-translate/core";
import {Temporal} from "temporal-polyfill";
import PlainDate = Temporal.PlainDate;


const debug = initDebugger('AksjeeiereBekreftBeholdningKomponent');

@Component({
    selector: 'aksjeeiere-bekreft-beholdning',
    templateUrl: './aksjeeiere-bekreft-beholdning.html',
    styleUrls: ['./aksjeeiere-bekreft-beholdning.scss'],
    imports: [
        FormaterPlainDatePipe,
        PercentPipe,
        AksjenummerintervallerPipe,
        InlineMeldingKomponent,
        NgClass,
        AntallAksjerPerAksjeklasseKomponent,
        TranslateModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AksjeeiereBekreftBeholdningKomponent {
    @Input() modell!: BeholdningerSkjemamodell;
    @Input() innfoeringsdato!: PlainDate;
}
